// src/store/navStore.ts
import { create } from 'zustand'
import { getApiUrl } from '../api'

interface NavSubItem {
  id: number
  label: string
  href: string | null
}

export interface NavItem {
  id: number
  label: string
  href: string | null
  children: NavSubItem[]
}

interface NavStore {
  navItems: NavItem[]
  loaded: boolean
  loading: boolean
  fetchNavItems: () => Promise<void>
}

const CACHE_KEY = 'nav_items_cache'

export const useNavStore = create<NavStore>((set, get) => ({
  navItems: (() => {
    try {
      const cached = localStorage.getItem(CACHE_KEY)
      return cached ? JSON.parse(cached) : []
    } catch { return [] }
  })(),
  loaded: false,
  loading: false,
    fetchNavItems: async () => {
    if (get().loaded) return
    try {
        const res = await fetch(getApiUrl('/marubit/api/nav'))
        if (res.ok) {
            const data = await res.json()
            localStorage.setItem(CACHE_KEY, JSON.stringify(data))
            set({ navItems: data, loaded: true })
        }
        } catch {}
    },
}))